import { Fragment, type CSSProperties } from 'react';
import { transcriptParts } from '@lib/transcript-view';

/**
 * PART D (William, 16 Oct 2026: "Clean this up"): the case's message and its transcript, with each
 * `system: Intake captured: {...}` line shown as a short labelled block (lib/transcript-view.ts) and every
 * line wrapped, so nothing runs off the right edge. Every other line is shown exactly as written.
 */
const WRAP: CSSProperties = { whiteSpace: 'pre-wrap', overflowWrap: 'anywhere', wordBreak: 'break-word' };

export function TranscriptText({ text, className, style, mono = false }: { text: string; className?: string; style?: CSSProperties; mono?: boolean }) {
  const parts = transcriptParts(text);
  return (
    <div className={[className, mono ? 'mono' : ''].filter(Boolean).join(' ')} style={{ ...WRAP, ...style }} data-testid="transcript-text">
      {parts.map((p, i) => (
        <Fragment key={i}>
          {p.kind === 'line' ? (
            <div style={WRAP}>{p.text || ' '}</div>
          ) : (
            <div
              data-testid="intake-block"
              style={{ margin: '4px 0', padding: '6px 10px', borderLeft: '3px solid var(--line, #ccc)', background: 'var(--paper-2, transparent)', fontFamily: 'inherit' }}
            >
              <div className="micro" style={{ marginBottom: 2 }}>Intake captured</div>
              {p.fields.map((f) => (
                <div key={f.label} style={WRAP}>
                  <span className="muted">{f.label}:</span> {f.value}
                </div>
              ))}
            </div>
          )}
        </Fragment>
      ))}
    </div>
  );
}
